$(function() {

  $('.order-rating').rating({
    theme: 'krajee-svg',
    language: 'it',
    stars: 5,
    filledStar: '<span class="krajee-icon krajee-icon-star"></span>',
    emptyStar: '<span class="krajee-icon krajee-icon-star"></span>',
    containerClass: '',
    size: 'xs',
    animate: false,
    showClear: false,
    showCaption: false
  });

  $('.order-rating').on('rating.change', function(e, v, c) {
    var $this = $(e.target),
        targetProduct = $this.data('product'),
        ratingValue = v;

    console.log($this);
    console.log(targetProduct);
    console.log(ratingValue);
  });

});
